import { render, staticRenderFns } from "./CasesGridClient.vue?vue&type=template&id=b256bd2a&scoped=true&"
import script from "./CasesGridClient.vue?vue&type=script&lang=js&"
export * from "./CasesGridClient.vue?vue&type=script&lang=js&"
import style0 from "./CasesGridClient.vue?vue&type=style&index=0&id=b256bd2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b256bd2a",
  null
  
)

export default component.exports